import { createContext, useContext } from 'react'
import type { DiscountCtxState } from '../data/useDiscountCtx'
import type { CountResult } from '../data/useAudienceCount'
import type { Ctx, DiscountKind, Draft, RecipeId, StepKey } from '../model'

export interface WizardActions {
  pickType: (kind: DiscountKind) => void
  applyRecipe: (id: RecipeId) => void
  /** "Todos os clientes" sem data para acabar é um Padrão. */
  toDefault: () => void
  turnOnNotify: () => void
  turnOffNotify: () => void
}

/** O que as etapas precisam saber do cadastro em andamento. */
export interface Wiz {
  d: Draft
  c: Ctx
  set: (fn: (d: Draft) => Draft) => void
  /** Erros do campo, só depois da primeira tentativa de avançar na etapa. id do campo -> mensagem. */
  fe: Record<string, string>
  locked: boolean
  step: StepKey
  stepIndex: number
  maxStep: number
  goStep: (i: number) => void
  act: WizardActions
  /** Chave para o campo "mesmo desconto em todos": mantida aqui para sobreviver a troca de etapa. */
  sameText: string
  setSameText: (v: string) => void
  /** Padrão em vigor, etiquetas, grupos e cidades: o estado de cada lista e como pedir de novo. */
  lists: DiscountCtxState['lists']
  /** Contas de cidade da rede (quantos clientes têm cidade e quantos há em cada uma). */
  cityStats: DiscountCtxState['cityStats']
  /** Quantos clientes o público escolhido alcança (etiquetas, grupos e cidades). */
  audienceCount: CountResult
}

export const WizardContext = createContext<Wiz | null>(null)

export function useWiz(): Wiz {
  const v = useContext(WizardContext)
  if (!v) throw new Error('useWiz fora do WizardContext')
  return v
}
